import React from 'react';

export function Badge({
    children,
    tone = 'neutral',
    className = '',
}: {
    children: React.ReactNode;
    tone?: 'neutral' | 'accent';
    className?: string;
}) {
    return <span className={['ds-badge', tone === 'accent' ? 'ds-badge--accent' : '', className].filter(Boolean).join(' ')}>{children}</span>;
}
